import styled from "styled-components";
import type { GlobalToken } from "antd";
import { radius } from "@libertify/ui";

const paneBase = `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: ${radius.box}px;
`;

export const PreviewFrame = styled.div<{ $token: GlobalToken }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 24px;
  border: 1.5px solid ${({ $token }) => $token.colorPrimaryBorder};
  border-radius: ${radius.box}px;
  background: ${({ $token }) => $token.colorPrimaryBg};
`;

export const PreviewStage = styled.div`
  display: flex;
  gap: 12px;
  align-items: stretch;
  width: 100%;
  max-width: 340px;
  height: 150px;
`;

export const SideGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 108px;
  flex: none;
`;

export const DocumentPane = styled.div<{ $token: GlobalToken }>`
  ${paneBase};
  flex: 1 1 auto;
  border: 1px solid ${({ $token }) => $token.colorBorderSecondary};
  background: ${({ $token }) => $token.colorBgContainer};
  color: ${({ $token }) => $token.colorTextTertiary};
`;

export const KnowledgeHubPane = styled.div<{ $token: GlobalToken }>`
  ${paneBase};
  flex: 1 1 auto;
  background: ${({ $token }) => $token.colorPrimaryBorder};
  color: ${({ $token }) => $token.colorPrimaryActive};
`;

export const ChatPane = styled.div<{ $token: GlobalToken }>`
  ${paneBase};
  flex: none;
  height: 42px;
  border: 1px solid ${({ $token }) => $token.colorBorderSecondary};
  background: ${({ $token }) => $token.colorBgContainer};
  color: ${({ $token }) => $token.colorTextTertiary};
`;

export const PaneLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
`;
